import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {LocationChangeAction} from '@web/actions/application'
import {NPAY_BIZ} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'
import {getUrlInfo} from '@web/helpers/path'

import {NavigationResult, ThunkApi} from '../interfaces'

type NavigateToNpayBizEasyCardRegister = {
    channel: string
    successUrlQuery?: Record<string, string>
}

/**
 * NpayBiz 간편결제 카드 등록 페이지로 이동
 */
const navigateToNpayBizEasyCardRegister = createAsyncThunk<
    NavigationResult,
    NavigateToNpayBizEasyCardRegister,
    ThunkApi
>('navigateTo/npayBizEasyCardRegister', async (args) => {
    const {channel, successUrlQuery} = args

    const easyCardRegisterUrl = `${NPAY_BIZ}/simplepay/${channel}/card/register`

    const url = qs.stringifyUrl({
        url: easyCardRegisterUrl,
        query: {
            successUrl: getUrlInfo({url: window.location.href, addQuery: successUrlQuery}).url,
            failUrl: window.location.href,
        },
    })

    changeBrowserLocation({url, type: LocationChangeAction.PUSH})
})

export default navigateToNpayBizEasyCardRegister
